import React from "react";

const TextWithUrlsHashTagsForNotification = ({
  text,
  urls = [],
  hashtags = [],
  onHashtagClick,
  actionDisabled,
  tagActivityTenantId,
  displayName,
}) => {
  const renderRemainingText = (line) => {
    const urlList = Array.isArray(urls)
      ? urls
      : typeof urls === "string" && urls
      ? [urls]
      : [];

    const isUrlRegex = /^(https?:\/\/|www\.|[a-zA-Z0-9-]+\.(com|org|net|io|co|in|edu|gov|me|info|biz|dev|app|store|tech)(\/|\b|\?|#))/i;
    const hashtagList = Array.isArray(hashtags) ? hashtags : [];

    return line.split(/\s+/).map((part, index) => {
      const cleanPart = part.trim();
      if (!cleanPart) return null;

      const isUrl =
        (urlList.length > 0 && urlList.some((url) => url && cleanPart.includes(url))) ||
        isUrlRegex.test(cleanPart);

      // URL case
      if (isUrl) {
        let url = cleanPart;
        if (!/^https?:\/\//i.test(url)) {
          url = "https://" + cleanPart;
        }
        return (
          <a
            href={url}
            target="_blank"
            key={index}
            rel="noopener noreferrer"
            style={{ fontSize: "14px" }}
          >
            {"related link "}
          </a>
        );
      }

      // Hashtag case
      const isHashtag =
        (cleanPart.startsWith("#") && cleanPart.length > 1) ||
        hashtagList.some(
          (hashtag) =>
            hashtag &&
            (cleanPart === hashtag ||
              cleanPart === `#${hashtag}` ||
              `#${cleanPart}` === hashtag)
        );

      if (isHashtag) {
        return (
          <span
            key={index}
            style={{
              color: "#007bff",
              cursor: onHashtagClick ? "pointer" : "default",
              fontSize: "14px",
            }}
            onClick={() => {
              if (onHashtagClick) {
                const rawTag = cleanPart.startsWith("#")
                  ? cleanPart.slice(1)
                  : cleanPart;
                onHashtagClick(
                  tagActivityTenantId
                    ? { hashtag: rawTag, tenantId: tagActivityTenantId }
                    : rawTag
                );
              }
            }}
          >
            {`${cleanPart} `}
          </span>
        );
      }

      return (
        <React.Fragment key={index}>
          {`${cleanPart} `}
        </React.Fragment>
      );
    });
  };

  const renderTextWithLinksAndTags = (text) => {
    if (!text) return null;

    const normalized = text.replace(/\\n/g, "\n");
    const lines = normalized.split("\n");

    return lines.map((line, lineIndex) => {
      if (!displayName) return renderRemainingText(line);

      const displayNameIndex = line.toLowerCase().indexOf(displayName.toLowerCase());

      if (displayNameIndex === -1) {
        // displayName not found in line
        return (
          <React.Fragment key={lineIndex}>
            {renderRemainingText(line)}
            {lineIndex !== lines.length - 1 && <br />}
          </React.Fragment>
        );
      }

      const before = line.slice(0, displayNameIndex);
      const boldName = line.slice(displayNameIndex, displayNameIndex + displayName.length);
      const after = line.slice(displayNameIndex + displayName.length);

      return (
        <React.Fragment key={lineIndex}>
          {renderRemainingText(before)}
          <span
            style={{
              fontWeight: "bold",
              color: "#000",
              fontSize: "14px",
            }}
          >
            {boldName}
          </span>
          {" "}
          {renderRemainingText(after)}
          {lineIndex !== lines.length - 1 && <br />}
        </React.Fragment>
      );
    });
  };

  return (
    <span
      style={{
        fontSize: "14px",
        pointerEvents: actionDisabled ? "none" : "auto",
        opacity: actionDisabled ? 0.6 : 1,
      }}
    >
      {renderTextWithLinksAndTags(text)}
    </span>
  );
};

export default TextWithUrlsHashTagsForNotification;